@if (lock.isLocked()) {
<div
  class="system-lock-banner"
  [class.system-lock-banner--maintenance]="maintenanceEnabled()"
  role="status"
>
  <icon name="info" />
  <span>{{ lock.lockReason() }}</span>
</div>
}
